import { SpecialOpeningHours } from "@greeter/core";
import { TimeInput } from "../TimeInput";
import { DateInput } from "../DateInput";
import { DatePeriod, TimeOfDay, withTimeOfDay } from "@greeter/date";
import {
  addDays,
  addSeconds,
  differenceInHours,
  set,
  subHours,
  isValid,
} from "date-fns";

import css from "./SpecialOpeningHoursInput.module.scss";
import { Log } from "@greeter/log";

export type SpecialOpeningHoursInputProps = {
  value: SpecialOpeningHours;
  onChange: (specialOpeningHours: SpecialOpeningHours) => void;
  theme?: "dark" | "light";
};

export function SpecialOpeningHoursInput(props: SpecialOpeningHoursInputProps) {
  return (
    <div className={css.SpecialOpeningHoursInput}>
      <div style={{ gridArea: "a", textAlign: "left" }}>
        <span style={{ textAlign: "left", width: "100%" }}>Dato</span>
        <DateInput
          theme={props.theme}
          value={props.value.period.from}
          style={{ gridArea: "a" }}
          onChange={(d) => {
            const from = set(
              isValid(props.value.period.from)
                ? new Date(props.value.period.from)
                : new Date(),
              {
                year: d.getFullYear(),
                month: d.getMonth(),
                date: d.getDate(),
              }
            );

            let to = set(
              isValid(props.value.period.to)
                ? new Date(props.value.period.to)
                : new Date(),
              {
                year: d.getFullYear(),
                month: d.getMonth(),
                date: d.getDate(),
              }
            );
            if (to <= from) to = addDays(to, 1);
            // Ensure that the diff is not larger than 24 hours.
            const diffInHours = differenceInHours(to, from);
            if (diffInHours >= 24) {
              to = subHours(to, diffInHours); // Clamps to maximally 24 hours
            }
            const result = {
              ...props.value,
              period: new DatePeriod({
                from: from,
                to: to,
              }),
            };
            props.onChange(result);
          }}
        />
      </div>
      <div style={{ gridArea: "b", textAlign: "left" }}>
        <span>Fra</span>
        <TimeInput
          theme={props.theme}
          style={{ gridArea: "b" }}
          onChange={(tod) => {
            const from = withTimeOfDay(props.value.period.from, tod);
            let to = props.value.period.to;

            if (from > to) {
              to = addDays(to, 1);
            }

            const period = new DatePeriod({ from, to });

            props.onChange({ ...props.value, period });
          }}
          value={TimeOfDay.fromDate(props.value.period.from)}
        />
      </div>
      <div style={{ gridArea: "d", textAlign: "left" }}>
        <span>Til</span>
        <TimeInput
          theme={props.theme}
          onChange={(tod) => {
            const from = props.value.period.from;
            let to = addSeconds(
              props.value.period.from,
              TimeOfDay.fromDate(props.value.period.from)
                .difference(tod)
                .getTotalSeconds()
            );
            if (from > to) {
              to = addDays(to, 1);
            }

            const period = new DatePeriod({ from, to });

            props.onChange({ ...props.value, period });
          }}
          value={TimeOfDay.fromDate(props.value.period.to)}
        />
      </div>
    </div>
  );
}

export default SpecialOpeningHoursInput;
